import { render, staticRenderFns } from "./IsisDropdownInfinity.vue?vue&type=template&id=5867a5b8&scoped=true&"
import script from "./IsisDropdownInfinity.vue?vue&type=script&lang=js&"
export * from "./IsisDropdownInfinity.vue?vue&type=script&lang=js&"
import style0 from "./IsisDropdownInfinity.vue?vue&type=style&index=0&id=5867a5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867a5b8",
  null
  
)

export default component.exports